import { render } from "./casinoGamePopup.vue?vue&type=template&id=ffbd7216&ts=true"
import script from "./casinoGamePopup.vue?vue&type=script&lang=ts"
export * from "./casinoGamePopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__